(() => {
  'use strict';

  const chooserForPage = () => document.querySelector(
    '.section-matchboox-home [data-mb40-chooser], .mb-global-footer__browse [data-mb-discovery]:not(.mb-discovery--recommendations-only)'
  );

  const openChooser = (name) => {
    const chooser = chooserForPage();
    if (!chooser) return false;
    const discovery = chooser.matches('[data-mb-discovery]')
      ? chooser
      : chooser.querySelector('[data-mb-discovery]');
    const triggerChooser = () => {
      const tab = name && name !== 'all'
        ? chooser.querySelector(`[data-mb-discovery-tab="${name}"]`)
        : null;
      if (typeof discovery?._mbOpenTab === 'function') {
        discovery._mbOpenTab(name || 'all');
        return true;
      }
      if (tab) {
        if (tab.getAttribute('aria-expanded') !== 'true') tab.click();
        return true;
      }
      return false;
    };

    if (!triggerChooser()) {
      let attempts = 0;
      const waitForDiscovery = window.setInterval(() => {
        attempts += 1;
        if (triggerChooser() || attempts >= 50) window.clearInterval(waitForDiscovery);
      }, 40);
    }

    const scrollToOpenedContent = () => {
      const headerOffset = () => {
        const header = document.querySelector('.section-matchboox-header, .section-header');
        if (!header) return 104;
        const style = window.getComputedStyle(header);
        const stickyTop = style.position === 'sticky' || style.position === 'fixed' ? (parseFloat(style.top) || 0) : 0;
        return header.getBoundingClientRect().height + stickyTop;
      };
      /* De hoofdkeuzes openen vanuit de header direct bij hun vervolgkeuzelijst. */
      const targetFor = () => {
        const openedChoices = discovery?.querySelector('[data-mb-discovery-choices]');
        return ['authors', 'illustrators', 'designers', 'themes', 'collection'].includes(name) && openedChoices && !openedChoices.hidden
          ? openedChoices
          : chooser;
      };
      const wanted = () => Math.max(0, Math.min(
        targetFor().getBoundingClientRect().top + window.scrollY - headerOffset() - 3.78,
        document.documentElement.scrollHeight - window.innerHeight
      ));
      const token = {};
      window.__mbScrollToken = token;
      let cancelled = false;
      const cancel = () => { cancelled = true; };
      const events = ['wheel', 'touchstart', 'keydown'];
      events.forEach((type) => window.addEventListener(type, cancel, { passive: true }));
      const stop = () => events.forEach((type) => window.removeEventListener(type, cancel));
      window.scrollTo({ top: wanted(), behavior: 'smooth' });
      const started = Date.now();
      let lastY = -1;
      const check = () => {
        if (cancelled || window.__mbScrollToken !== token) return stop();
        const y = window.scrollY;
        const settled = Math.abs(y - lastY) < 1;
        lastY = y;
        if (settled && Math.abs(y - wanted()) > 3) window.scrollTo({ top: wanted(), behavior: 'smooth' });
        if (Date.now() - started < 2600) window.setTimeout(check, 140);
        else stop();
      };
      window.setTimeout(check, 140);
    };
    window.setTimeout(() => window.requestAnimationFrame(() => window.requestAnimationFrame(scrollToOpenedContent)), 90);
    return true;
  };

  const init = () => {
    const header = document.querySelector('.mb-site-header--unified');
    if (!header || header.dataset.mbHeaderReady === 'true') return;
    header.dataset.mbHeaderReady = 'true';

    header.querySelectorAll('[data-mb-header-chooser]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (!openChooser(link.dataset.mbHeaderChooser)) return;
        event.preventDefault();
        link.closest('details')?.removeAttribute('open');
      });
    });

    const requested = new URLSearchParams(window.location.search).get('mbchooser');
    if (requested && chooserForPage()) {
      window.setTimeout(() => openChooser(requested), 80);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
